export default __webpack_public_path__ + "b87a20f18248dbc8732614c794f51666.png";